import React, { useState } from 'react';
import { Tag, Table, Button, Modal, Input, Tooltip } from 'antd';

import { InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

import { uniq, orderBy, sortBy } from 'lodash';
import moment from 'moment';

import { rabbitSignFieldTypes } from './../../../../../../../shared/constants/enums';
import { getSignerColor, getRabbitSignTemplateClientOptionName } from './../../../../../../../shared/utils';
const RabbitSignTemplateModal = ({
  visible,
  close,
  cancel,
  rootContainer,
  hadleDeleteTemplateClick,
  loading,
  pageRequest,
  loadData,
  dataList,
  totalRecords,
  totalSigners,
}) => {
  const [chosenTemplate, setChosenTemplate] = useState(null);

  const fieldTypes = Object.values(rabbitSignFieldTypes);

  const assign = () => {
    close(chosenTemplate);
  };

  const onSearch = (value) => {
    const params = { ...pageRequest, ...{ pageNumber: 1, pageSize: 5, searchString: value } };
    loadData(params);
  };

  const renderTotal = (total, range) => `${range[0]}-${range[1]} of ${total} templates`;

  const onPageChange = (page, pageSize) => {
    const newParams = { ...pageRequest, ...{ pageNumber: page, pageSize: pageSize } };

    loadData(newParams);
  };

  const onDeleteTemplate = (record) => {
    return Modal.confirm({
      getContainer: rootContainer,
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure to delete this template?',
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => hadleDeleteTemplateClick(record),
    });
  };

  return (
    <>
      <Modal
        title="Assign a template"
        centered
        open={visible}
        onCancel={() => cancel()}
        onOk={() => assign()}
        width={1000}
        maskClosable={false}
        footer={[
          <Button key="back-assign-template" onClick={() => cancel()}>
            Cancel
          </Button>,
          <Button key="save-assign-template" type="primary" onClick={() => assign()}>
            Save
          </Button>,
        ]}
        getContainer={rootContainer}
      >
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0px 20px 0px' }}>
            <Input.Search
              allowClear
              key="rabbit-sign-template-search-val"
              placeholder="Enter template name"
              loading={loading}
              onSearch={(value) => onSearch(value)}
              enterButton
              style={{ width: '50%' }}
            />
          </div>
          <div style={{ display: 'flex' }}>
            <Table
              key="rabbit-sign-templates-table"
              rowKey={(record) => record.id}
              loading={loading}
              tableLayout={'fixed'}
              rowSelection={{
                type: 'radio',
                onChange: (selectedRowKeys, selectedRows) => {
                  if (selectedRows?.length) {
                    setChosenTemplate(selectedRows[0]);
                  }
                },
                getCheckboxProps: (record) => {
                  const tempSigners = uniq(record?.rabbitSignFieldSettings?.map((obj) => obj.email)).length;

                  return {
                    disabled: tempSigners < totalSigners,
                  };
                },
              }}
              columns={[
                {
                  title: 'Name',
                  dataIndex: 'name',
                  key: 'rabbit-template-names',
                  render: (_, record) => {
                    const tempSigners = uniq(record?.rabbitSignFieldSettings?.map((obj) => obj.email)).length;

                    return (
                      <a
                        title={
                          tempSigners < totalSigners
                            ? `This template can't be used. At least ${totalSigners} signers should in template.`
                            : record.name
                        }
                      >
                        {record.name}
                      </a>
                    );
                  },
                  ellipsis: true,
                  fixed: 'left',
                  width: 200,
                },

                {
                  title: 'Clients',
                  key: 'rabbit-template-clients',
                  className: 'rabbit-template-signers-columns',
                  width: 250,
                  fixed: 'left',
                  render: (_, record) => {
                    const getFieldsByEmail = (signerEmail) => {
                      const signerFields = uniq(
                        record?.rabbitSignFieldSettings?.filter((obj) => obj.email == signerEmail)?.map((obj) => obj.fieldType),
                      );

                      return signerFields;
                    };

                    const tooltipKeyPrefix = 'rabbit-template-email-tooltip-' + record.id;

                    const signerEmails = uniq(record?.rabbitSignFieldSettings?.map((obj) => obj.email));

                    const uniqClients = orderBy(
                      signerEmails?.map((email) => {
                        const signer = record?.rabbitSignFieldSettings?.find((obj) => obj.email === email);

                        return { email: signer.email, contactType: signer.contactType };
                      }),
                      ['contactType'],
                      ['asc'],
                    );

                    return (
                      <>
                        {uniqClients.map((obj, index) => {
                          const signer = {
                            email: obj.email,
                            signerLabel: 'Client ' + (index + 1),
                            signerColor: getSignerColor(index),
                          };

                          const tooltipKey = tooltipKeyPrefix + '-wrap-' + obj.email;
                          const signerFields = getFieldsByEmail(obj.email);

                          const optName = getRabbitSignTemplateClientOptionName(signer, tooltipKeyPrefix+ '-coption-'+ index);

                          return (
                            <div id={tooltipKey} style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                              <Tooltip
                                placement='topLeft'
                                key={tooltipKeyPrefix + '-' + obj.email}
                                getPopupContainer={() => document.getElementById(tooltipKey)}
                                title={
                                  <div  style={{whiteSpace: 'break-spaces',}} key={tooltipKeyPrefix + '-' + obj.email + '-title'}>
                                    <p>Client info</p>

                                    <p>Email: {obj.email}</p>
                                    <p>
                                      Fields used:{' '}
                                      {signerFields.map((fieldTypeValue) => {
                                        const field = fieldTypes[fieldTypeValue];

                                        return (
                                          <Tag color={field.color} key={'email-field-type-' + fieldTypeValue}>
                                            {field?.text}
                                          </Tag>
                                        );
                                      })}
                                    </p>
                                  </div>
                                }
                              >
                                {optName}
                              </Tooltip>
                            </div>
                          );
                        })}
                      </>
                    );
                  },
                },
                {
                  title: 'Create Date',
                  dataIndex: 'createDate',
                  ellipsis: true,
                  key: 'rabbit-template-names',
                  width: 180,
                  render: (_, record) => <>{moment(record.createDate).format('MMM DD, YYYY hh:mm A')}</>,
                },
                {
                  title: 'Change Date',
                  dataIndex: 'changeDate',
                  ellipsis: true,
                  key: 'rabbit-template-names',
                  width: 180,
                  render: (_, record) => <>{moment(record.changeDate).format('MMM DD, YYYY hh:mm A')}</>,
                },
                {
                  title: 'More',
                  key: 'rabbit-template-more-info',
                  fixed: 'right',
                  width: 60,
                  render: (_, record) => {
                    const docs = uniq(record?.rabbitSignFieldSettings?.map((obj) => obj.docNumber))?.length;
                    const tooltipWrap = 'rabbit-template-more-tooltip-' + record.id;
                    const uniqFields = uniq(record?.rabbitSignFieldSettings?.map((obj) => obj.fieldType));

                    return (
                      <div id={tooltipWrap}>
                        <Tooltip
                          placement="left"
                          getPopupContainer={() => document.getElementById(tooltipWrap)}
                          title={
                            <>
                              {docs && <p>Documents used: {<Tag key={'rabbit-template-more-docs-' + record.id}>{docs}</Tag>}</p>}
                              {uniqFields && (
                                <p>
                                  Fields used:{' '}
                                  {uniqFields.map((fieldTypeValue) => {
                                    const field = fieldTypes[fieldTypeValue];

                                    return (
                                      <Tag color={field.color} key={'email-field-type-' + fieldTypeValue}>
                                        {field?.text}
                                      </Tag>
                                    );
                                  })}
                                </p>
                              )}
                            </>
                          }
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      </div>
                    );
                  },
                },
                {
                  title: 'Actions',
                  key: 'rabbit-template-actions',
                  render: (_, record) => <a onClick={() => onDeleteTemplate(record)}>Delete</a>,
                  fixed: 'right',
                  width: 70,
                },
              ]}
              dataSource={dataList}
              pagination={{
                size: 'small',
                showQuickJumper: false,
                defaultPageSize: 5,
                pageSizeOptions: [5, 10, 15, 20],
                pageSize: pageRequest.pageSize,
                current: pageRequest.pageNumber,
                total: totalRecords,
                showTotal: (total, range) => renderTotal(total, range),
                onChange: (page, pageSize) => onPageChange(page, pageSize),
              }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RabbitSignTemplateModal;
